<template>
  <div class="ap-tool">
    <!-- 请求配置 -->
    <div class="editor-pane">
      <div class="ap-row">
        <el-select v-model="method" size="small" style="width:100px;">
          <el-option v-for="m in methods" :key="m" :label="m" :value="m" />
        </el-select>
        <el-input v-model="url" size="small" placeholder="https://api.example.com/endpoint" class="ap-mono ap-flex" @keyup.enter="send" />
        <el-button type="primary" size="small" @click="send" :loading="loading">{{ $t("common.action.submit") }}</el-button>
      </div>
      <el-collapse v-model="panels" style="margin-top:10px;">
        <el-collapse-item title="Headers" name="headers">
          <div class="ap-kv">
            <div v-for="(h,i) in headers" :key="i" class="ap-kv-row">
              <el-input v-model="h.key" size="mini" placeholder="Key" style="width:140px;" class="ap-mono" />
              <el-input v-model="h.value" size="mini" placeholder="Value" class="ap-mono ap-flex" />
              <el-button size="mini" type="text" icon="el-icon-delete" @click="headers.splice(i,1)" />
            </div>
            <el-button size="mini" @click="headers.push({key:'',value:''})">+ {{ $t('tool.ApiTester.addHeader') }}</el-button>
          </div>
        </el-collapse-item>
        <el-collapse-item title="Body" name="body" v-if="method!=='GET'&&method!=='HEAD'">
          <el-input v-model="body" type="textarea" :rows="6" placeholder='{"key":"value"}' class="ap-mono" />
          <div style="margin-top:8px;display:flex;gap:8px;">
            <el-radio-group v-model="contentType" size="mini">
              <el-radio-button label="json">JSON</el-radio-button>
              <el-radio-button label="form">Form</el-radio-button>
              <el-radio-button label="text">Text</el-radio-button>
            </el-radio-group>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- 响应 -->
    <div class="editor-pane" v-if="response">
      <div class="ap-resp-bar">
        <span :class="['ap-status',statusClass]">{{ response.status }} {{ response.statusText }}</span>
        <span class="ap-time">{{ response.time }}ms</span>
        <span class="ap-size">{{ response.size }}</span>
      </div>
      <div class="ap-resp-body">
        <pre><code>{{ response.body }}</code></pre>
      </div>
      <div style="margin-top:10px;display:flex;gap:8px;">
        <el-button size="small" @click="copy(response.body)">{{ $t('tool.ApiTester.copyBody') }}</el-button>
        <el-button size="small" @click="copy(JSON.stringify({status:response.status,body:response.body},null,2))">{{ $t('tool.ApiTester.copyAll') }}</el-button>
      </div>
    </div>
    <div class="editor-pane" v-if="error">
      <div class="ap-err">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'ApiTesterTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({
    method:'GET',url:'',headers:[{key:'Content-Type',value:'application/json'}],
    body:'',contentType:'json',loading:false,response:null,error:'',
    panels:['headers','body'],
    methods:['GET','POST','PUT','PATCH','DELETE','HEAD','OPTIONS']
  }),
  computed:{
    statusClass(){
      if(!this.response)return''
      const s=this.response.status
      if(s>=200&&s<300)return'ap-ok';if(s>=300&&s<400)return'ap-redir';if(s>=400)return'ap-err'
      return''
    }
  },
  methods:{
    fmtSize(b){if(!b)return'0B';return b<1024?b+'B':b<1048576?(b/1024).toFixed(1)+'KB':(b/1048576).toFixed(2)+'MB'},
    async send(){
      if(!this.url.trim())return;this.loading=true;this.response=null;this.error=''
      const start=Date.now()
      try{
        const opts={method:this.method}
        // headers
        const hdrs={}
        this.headers.forEach(h=>{if(h.key.trim())hdrs[h.key.trim()]=h.value})
        if(Object.keys(hdrs).length)opts.headers=hdrs
        // body
        if(this.method!=='GET'&&this.method!=='HEAD'&&this.body.trim()){
          if(this.contentType==='json'){opts.body=this.body;if(!hdrs['Content-Type'])hdrs['Content-Type']='application/json'}
          else if(this.contentType==='form'){
            const params=new URLSearchParams()
            this.body.split('\n').forEach(line=>{const i=line.indexOf('=');if(i>-1)params.append(line.slice(0,i).trim(),line.slice(i+1).trim())})
            opts.body=params
            if(!hdrs['Content-Type'])hdrs['Content-Type']='application/x-www-form-urlencoded'
          }else{opts.body=this.body}
          opts.headers=hdrs
        }
        const res=await fetch(this.url,opts)
        const text=await res.text()
        const time=Date.now()-start
        let body=text
        try{body=JSON.stringify(JSON.parse(text),null,2)}catch(e){}
        this.response={status:res.status,statusText:res.statusText,body,time,size:this.fmtSize(new Blob([text]).size)}
      }catch(e){this.error=this.$t('tool.ApiTester.errRequest')+': '+e.message}
      this.loading=false
    },
    copy(t){navigator.clipboard.writeText(t);this.$message.success(this.$t("common.status.copied"))},
    doAction(a){if(a==='clear'){this.url='';this.body='';this.response=null;this.error=''}}
  }
}
</script>

<style scoped>
.ap-tool { display:flex;flex-direction:column;gap:14px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; }
.ap-row { display:flex;gap:8px; }
.ap-mono >>> input,.ap-mono >>> textarea { font-family:'JetBrains Mono','Consolas',monospace!important;font-size:13px!important; }
.ap-flex { flex:1; }
.ap-kv { }
.ap-kv-row { display:flex;gap:6px;align-items:center;margin-bottom:6px; }

.ap-resp-bar { display:flex;align-items:center;gap:12px;margin-bottom:10px; }
.ap-status { font-weight:700;font-size:14px; }
.ap-ok { color:#67c23a; }
.ap-redir { color:#e6a23c; }
.ap-err { color:#f56c6c; }
.ap-time,.ap-size { font-size:12px;color:#8892a6; }
.ap-resp-body { background:#fff;border:1px solid #e4e7ed;border-radius:8px;padding:14px;max-height:400px;overflow:auto; }
.ap-resp-body pre { margin:0;white-space:pre-wrap;word-break:break-all;font-size:13px;font-family:monospace;color:#303133;line-height:1.6; }
.ap-err { color:#f56c6c;font-size:13px; }
</style>
